<template>
  <hr
    class="tw-border-light-gray-2 tw-my-3"
    :class="customClass"
  >
</template>

<script setup lang="ts">
const props = defineProps({
  customClass: {
    type: String,
    default: '',
  },
})
</script>

